import { IconButton, InputAdornment, List, ListItem, ListItemText, Popover, TextField } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react'

const SearchField = ({ 
        textInitial,
        onTextRender,
        items,
        onFilterItems,
        onSelectItem,
        onRenderItem
}) => {
    const refInput = useRef(null)
    const [textFilter, setTextFilter] = useState(textInitial)
    const [anchorEl, setAnchorEl] = useState(null);
    const [height, setHeight] = useState(200);

    const openList = Boolean(anchorEl)

    const handleTextChange = event => {
        const value = event.target.value
        setTextFilter(value)
    }

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setTimeout(() => setAnchorEl(null), 100)
    }

    const handleItemSelect = item => {
        onSelectItem(item)
        setTextFilter(onTextRender(item))
    }

    const itemsFilter = onFilterItems(items, textFilter)

    useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              const { top } = entry.boundingClientRect;
              const newHeight = window.innerHeight - top - 100; // Ajusta la fórmula según la necesidad
              setHeight(newHeight);
            }
          },
          { threshold: 0.1 } // Umbral de visibilidad
        );
    
        const element = refInput.current;
        if (element) {
          observer.observe(element);
        }
    
        return () => {
          if (element) observer.unobserve(element);
        };
      }, []);

    return (
        <div>
            <TextField
                inputRef={refInput}
                value={textFilter}
                onClick={handleClick}
                onBlur={handleClose}
                onChange={handleTextChange}
                InputProps={{
                    endAdornment: 
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    setTextFilter("")
                                    refInput.current.focus()
                                }}>
                                <Clear />
                            </IconButton>
                        </InputAdornment>
                }}
            />
            <Popover
                id={openList ? 'simple-popover' : undefined}
                open={openList}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                disableAutoFocus={true}
            >
                <List style={{ maxHeight: height, overflow: 'auto' }}>
                    {itemsFilter.map(item =>
                        <ListItem key={item.id} button onClick={() => handleItemSelect(item)}>
                            <ListItemText primary={onRenderItem(item)} />
                        </ListItem>       
                    )}

                    {itemsFilter.length === 0 && 
                        <ListItem key='0'>
                            <ListItemText primary="Ningun elemento encontrado" />
                        </ListItem>
                    }
                </List>
            </Popover>
        </div>
    )
}

export default SearchField